import {Component, Injector, Input} from "@angular/core";
import {DxBaseControlComponent} from "../dx-base-control.component";
import {DxComboboxControlOptions} from "../../../domain/ui-options/dx-combobox-control-options";
import {DxComboDatasource} from "../../../domain/combo/dx-combo-datasource";
import {DxAppError} from "../../../../dx-core/domain/error/dx-app-error";
import {DxComboElementDataProvider} from "../../../domain/combo/dx-combo-element-data-provider";
import {SuiLocalizationService} from "ng2-semantic-ui";
import ru from "ng2-semantic-ui/locales/ru";


/**
 * Комбобокс с линейным списком элементов.
 * Поодержиывает:
 * 1. Прямую передачу данных
 * 2. Асинхронную загрузку данных через датасорс.
 */
@Component({
  selector: 'dx-combobox',
  templateUrl: './dx-combobox.component.html',
  styleUrls: ['./dx-combobox.component.css']
})
export class DxComboboxComponent extends DxBaseControlComponent {

  /** массив элементов, которые будут отображаться в комбике */
  @Input()
  public elements: DxComboElementDataProvider[];

  /** Опции контрола.*/
  public get controlOptions(): DxComboboxControlOptions {
    return <DxComboboxControlOptions>this.options;
  }

  /** Свойство доступности */
  @Input()
  set isDisabled(value: boolean) {
    this._isDisabled = value;
  }

  get isDisabled(): boolean {
    return this._isDisabled || this.isLoading; // || this.isLoadingError;
  }

  /** Свойство видимости */
  @Input()
  set isHidden(value: boolean) {
    this._isHidden = value;
  }

  @Input()
  clearable: boolean;

  /** Флаг индикации загрузки кобика */
  public isLoading: boolean = false;

  /** Признак ошибки загрузки данных */
  public isLoadingError: boolean = false;

  /** Датасорс для асинхронной работы с данными для комбика */
  private _dataSource: DxComboDatasource;

  constructor(public localizationService: SuiLocalizationService,
              private _injector: Injector) {
    super();
    localizationService.load("ru", ru);
    localizationService.setLanguage("ru");
  }

  protected _init(): void {
    super._init();
    this._errorMessages.set('loadingError', 'Ошибка загрузки данных');
    if (!this.options) this.options = new DxComboboxControlOptions();
    if (!this.controlOptions.valueField) this.controlOptions.valueField = 'id';
    if (!this.controlOptions.labelField) this.controlOptions.labelField = 'name';
    if (this.controlOptions.useServerSideModel) {
      if(!this.controlOptions.datasourceIdent) {
        throw new DxAppError('Комобобокс используется с серверной моделью данных, но датасорс не предоставлен!');
      }
      const filter = this.controlOptions.filter;
      const sorts = this.controlOptions.sorts;
      const dataSources = this._injector.get<DxComboDatasource>(<any> this.controlOptions.datasourceIdent);
      this._dataSource = dataSources[0];
      this.fetchElements(filter, sorts);
    } else {
      // Можно выполнить клиентскую сортировку и фильтрацию.
    }
  }

  public fetchElements(filter?: Map<string, Object>, sorts?: Map<string, string>): void {
    this._showLoader();
    this._dataSource.fetchElements(filter, sorts).subscribe(data => {
      this._hideLoader();
      this.elements = data;
    }, error => {
      this.showError(error);
      this.elements = [];
    });
  }

  /** Показывает индикацию загрузки. */
  protected _showLoader(): void {
    this.isLoading = true;
  }

  /** Скрывает индикацию загрузки. */
  protected _hideLoader(): void {
    this.isLoading = false;
  }

  /** Показывает ошибку, возникшую при загрузке \ обновлении данных. */
  public showError(message): void {
    this._hideLoader();
    this.isLoadingError = true;
    this.formControlInstance.markAsDirty();
    this.formControlInstance.setErrors({ loadingError: true});
  }

  getValueAsLabel(): string {
    if (!this.elements) {
      return '';
    }

    const item = this.elements.find(el => el[this.controlOptions.valueField] === this.formControlInstance.value);
    return item ? item[this.controlOptions.labelField] : '';
  }
}
